
const assetsObject = {
    carParking: require('assets/batteryCell.svg').default,
    carParkingRight: require('assets/Group 107 (1).svg').default,
    carParkingError:require('assets/batterySoc.svg').default,
    carParkingAvailable:require('assets/carParkingAvailable.svg').default,
    batteryCharge: require('assets/batteryCharge.svg').default,
    batteryPlugged: require('assets/batteryPlugged.svg').default,
    portError: require('assets/portError.svg').default,
    batteryError: require('assets/batteryError.svg').default,
    parkingStatus: require('assets/batterySoc.svg').default
  }
  module.exports = assetsObject